import $ from 'jquery'

function loadMore(e) {
	e.preventDefault();
	const button = $(this);

	const data = {
		'action': 'loadmore',
		'query': posts_ajax,
		'page' : current_page_ajax,
	};
 
	$.ajax({
		url : ajax_object.ajax_url,
		data : data,
		type : 'POST',
		beforeSend : function ( xhr ) {
			button.text('Loading...');
		},
		success : function( posts ){
			if( posts ) {
				button.text( 'Load more blog posts' );
				$('.js-members').append(posts);
				$('.js-members').find('.js-fadein').removeClass('js-fadein');
				current_page_ajax++;
  
				if ( current_page_ajax == max_page_ajax ) 
					button.hide();
  
			} else {
				button.hide();
			}
		}
	});
	return false;
}

function initLoadMore() {
	$(".js-load-more").on('mousedown', loadMore);
}

initLoadMore()